import React from "react";
import Images from "../data/Images";
import {
  ShieldCheck,
  AlarmClock,
  MapPin,
  School,
  Phone,
  Mail,
} from "lucide-react";

const Footer = () => {
  return (
    <footer className="border-t bg-white justify-between border-red-800 mt-32 text-lg text-black px-4 py-4">
      {/* Top CTA Section */}
      <div className="max-w-5xl mx-auto -mt-24 mb-12 px-4">
        <div className="bg-red-800 text-white p-6 sm:p-8 md:p-10 rounded-2xl shadow-2xl flex flex-col lg:flex-row justify-between items-start lg:items-center gap-10">
          <div className="text-lg w-full lg:w-1/2">
            <div className="text-lg font-semibold mb-1">
              Stay Updated with New Way Security
            </div>
            <p>
              Subscribe to our newsletter for security updates, training
              programs, and more.
            </p>
            <form className="mt-4 relative w-full sm:w-80">
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full rounded-md py-2 pl-4 pr-28 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-red-500"
              />
              <button
                type="submit"
                className="absolute right-1 top-1 bottom-1 bg-red-800 text-white px-4 rounded-md hover:bg-red-900 transition"
              >
                Subscribe
              </button>
            </form>
          </div>

          <div className="flex flex-col gap-4 text-lg text-white w-full lg:w-1/2">
            <div className="flex flex-row-reverse items-center justify-start gap-3">
              <ShieldCheck className="w-6 h-6" />
              <span>Licensed & Trusted Guards</span>
            </div>
            <div className="flex flex-row-reverse items-center justify-start gap-3">
              <AlarmClock className="w-6 h-6" />
              <span>24/7 Rapid Response</span>
            </div>
            <div className="flex flex-row-reverse items-center justify-start gap-3">
              <MapPin className="w-6 h-6" />
              <span>Serving Across Ontario</span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Main Content */}
      <div className="w-full max-w-7xl mx-auto px-4 py-8 flex flex-col md:flex-row md:justify-between items-start text-center md:text-left gap-8 flex-wrap">
        {/* Left Column - Logo & Contact */}
        <div className="flex flex-col space-y-3 w-full sm:w-auto text-center md:text-left">
          <img
            src={Images.logopng}
            className="h-24 w-auto max-w-full object-contain mx-auto md:mx-0"
            alt="logo"
          />

          {/* App Badges */}
          <div className="mt-4">
            <span className="font-semibold text-lg block mb-2">
              Download Our Apps
            </span>
            <div className="flex gap-2 justify-center md:justify-start flex-wrap">
              <a
                href="https://play.google.com/store"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Get it on Google Play"
                  className="h-10"
                />
              </a>
              <a
                href="https://www.apple.com/app-store/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="Download on the App Store"
                  className="h-10"
                />
              </a>
            </div>
          </div>

          <span className="font-semibold text-lg mt-4">
            Your Safety, Our Mission
          </span>

          {/* Contact Info */}
          <div className="mt-4 text-lg space-y-2 text-left">
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-red-800" />
              <span className="break-words">
                <strong>Head Office:</strong> 600 Matheson Blvd W, Unit 5 Inside
                Venture X, <br /> Mississauga, ON, L5R 4B8.
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-red-800" />
              <a href="tel:+14379850552" className="hover:text-red-800">
                +1 (437) 985 0552
              </a>
              <a href="tel:+14372863002" className="hover:text-red-800">
                +1 (437) 286 3002
              </a>
            </div>
            <div className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-red-800" />
              <a
                href="mailto:info@newwaysecurity.com"
                className="hover:text-red-800"
              >
                info@newwaysecurity.com
              </a>
            </div>
          </div>
        </div>

        {/* Middle Links Column */}
        <div className="flex flex-col text-lg space-y-1 w-full sm:w-auto">
          <a href="about" className="text-black hover:text-red-800">
            About Us
          </a>
          <a href="career" className="text-black hover:text-red-800">
            Careers
          </a>
          <a href="emergencies" className="text-black hover:text-red-800">
            Emergencies
          </a>
          <a href="location" className="text-black hover:text-red-800">
            Locations
          </a>
          <a href="services" className="text-black hover:text-red-800">
            Services
          </a>
          <a href="training" className="text-black hover:text-red-800">
            Training
          </a>
          <a href="technology" className="text-black hover:text-red-800">
            Technology
          </a>
        </div>

        {/* Right Links Column */}
        <div className="flex flex-col text-lg space-y-1 w-full sm:w-auto">
          <a href="certifications" className="text-black hover:text-red-800">
            Certifications
          </a>
          <a href="contact" className="text-black hover:text-red-800">
            Client Support
          </a>
          <a href="contact" className="text-black hover:text-red-800">
            Request a Quote
          </a>
          <a href="#" className="text-black hover:text-red-800">
            LinkedIn
          </a>
          <a href="#" className="text-black hover:text-red-800">
            YouTube
          </a>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="flex flex-col sm:flex-row justify-center sm:justify-between items-center text-sm text-black space-y-2 sm:space-y-0 mt-6 px-4 max-w-7xl mx-auto">
        <span className="text-center sm:text-left">
          © 2025 Newwaysecurity. All rights reserved
        </span>
        <div className="flex flex-wrap justify-center sm:justify-end space-x-4">
          <a href="privacy-policy" className="text-black hover:text-red-800">
            Privacy Policy
          </a>
          <a href="termsofuse" className="text-black hover:text-red-800">
            Terms of Use
          </a>
          <a href="/nws/admin/login.php" className="h-3 w-3 rounded-full"></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
